module.exports = __webpack_public_path__ + "static/media/loc3_img21.73343e17.jpg";